export const jewish_ghettos = `
<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <circle cx="6" cy="6" r="5.5" fill="#FC443A" stroke="#FC443A"/>
</svg>
`

export const transit_ghettos = `
<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M38 2V38H2V2H38Z" fill="white" stroke="#2C2C2C" stroke-width="4"/>
<circle cx="20.0026" cy="19.9999" r="6.66667" fill="#2C2C2C"/>
</svg>
`

export const extermination_camp = `
<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
  <rect x="3" y="3" width="58" height="58" fill="white" stroke="#2C2C2C" stroke-width="6"/>
  <path d="M40.2989 32L50.6693 42.3704L42.373 50.6667L32.0026 40.2963L21.6322 50.6667L13.3359 42.3704L23.7063 32L13.3359 21.6297L21.6322 13.3334L32.0026 23.7037L42.373 13.3334L50.6693 21.6297L40.2989 32Z" fill="#2C2C2C"/>
</svg>
`
